define('GoferParts.Details.View', [
  'Cart.QuickAddToCart.View',
  'SCView',
  'Product.Model',
  'gofer_parts_details.tpl',
  'Backbone'
], function (
  CartQuickAddToCartView,
  SCViewModule,
  ProductModel,
  gofer_parts_details_tpl,
  Backbone
) {
  'use strict';

  var SCView = SCViewModule.SCView;

  function GoferPartsDetailsView(options) {
    SCView.call(this, options);

    this.model = options.model;
    this.application = options.application;
    this.template = gofer_parts_details_tpl;

    this.childViews = {
      'Cart.QuickAddToCart': function () {
        var product = new ProductModel({
          item: this.model,
          quantity: this.model.get('_minimumQuantity', true)
        });
        return new CartQuickAddToCartView({
          model: product,
          application: this.application
        });
      }
    };
  }

  GoferPartsDetailsView.prototype = Object.create(SCView.prototype);
  GoferPartsDetailsView.prototype.constructor = GoferPartsDetailsView;

  GoferPartsDetailsView.prototype.getContext = function () {
    var url = SC.ENVIRONMENT.currentHostString;
    return {
      model: this.model,
      image: this.model.get('_thumbnail'),
      name: this.model.get('displayname'),
      pdpUrl: 'https://'+url+'/'+this.model.get('urlcomponent'),
      parentModel: this.model.get('parentModel'),
      type: this.model.get('type'),
      value: this.model.get('value'),
      storedescription: this.model.get('storedescription'),
    };
  };

  return GoferPartsDetailsView;
});
